import React, { useState, useEffect, useCallback, useMemo } from 'react';
import {
  LoyaltySidebarProps,
  LoyaltyData,
  LoyaltyHeaderProps,
  HeroCardProps,
  TierWidgetProps,
  GettingStartedProps,
  GettingStartedItem
} from './types';
import './../../scss/loyalty-sidebar.style.scss';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store';
import { fetchLoyaltyStatusAsync } from '../../features/loyalitystatus';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { bronzeMedal, silverMedal, goldMedal, platinumMedal, ironMedal } from './../../components/images/jpg/medalimages';
import { formatAmount } from '../../helper/common.helper';
import { get } from '../../api/api.service';

const TrendingUpIcon: React.FC = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M2 18L8.64645 11.3536C8.84171 11.1583 9.15829 11.1583 9.35355 11.3536L12.6464 14.6464C12.8417 14.8417 13.1583 14.8417 13.3536 14.6464L21 7M16 6H21.5C21.7761 6 22 6.22386 22 6.5V12"
      stroke="#6750B8"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>

);

// Arrow Right Icon Component
const ArrowRightIcon: React.FC = () => (
  <svg
    width={13}
    height={12}
    viewBox="0 0 13 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.835938 5.83594H11.6693M7.5026 0.835938L11.9133 5.24668C12.2388 5.57212 12.2388 6.09976 11.9133 6.42519L7.5026 10.8359"
      stroke="#3C2E6A"
      strokeWidth="1.67"
      strokeLinecap="round"
    />
  </svg>
);
const PresentIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={17}
      height={18}
      viewBox="0 0 17 18"
      fill="none"
    >
      <path
        d="M1.83333 7.66667V6.66667H0.833333V7.66667H1.83333ZM15.1667 7.66667H16.1667V6.66667H15.1667V7.66667ZM2.74335 16.6517L3.19734 15.7607L2.74335 16.6517ZM2.01499 15.9233L2.906 15.4693L2.01499 15.9233ZM14.985 15.9233L14.094 15.4693L14.985 15.9233ZM14.2567 16.6517L13.8027 15.7607L14.2567 16.6517ZM1.45501 7.57584L1.909 6.68483L1.45501 7.57584ZM1.09083 7.21166L1.98183 6.75767L1.09083 7.21166ZM15.9092 7.21166L15.0182 6.75767L15.9092 7.21166ZM15.545 7.57584L15.091 6.68483V6.68483L15.545 7.57584ZM15.545 4.42416L15.091 5.31517V5.31517L15.545 4.42416ZM15.9092 4.78834L15.0182 5.24233L15.9092 4.78834ZM1.45501 4.42416L1.909 5.31517L1.45501 4.42416ZM1.09083 4.78834L1.98183 5.24233L1.09083 4.78834ZM7.83333 7.66667C7.83333 7.11438 7.38562 6.66667 6.83333 6.66667C6.28105 6.66667 5.83333 7.11438 5.83333 7.66667H6.83333H7.83333ZM5.83333 16.8333C5.83333 17.3856 6.28105 17.8333 6.83333 17.8333C7.38562 17.8333 7.83333 17.3856 7.83333 16.8333H6.83333H5.83333ZM11.1667 7.66667C11.1667 7.11438 10.719 6.66667 10.1667 6.66667C9.61438 6.66667 9.16667 7.11438 9.16667 7.66667H10.1667H11.1667ZM9.16667 16.8333C9.16667 17.3856 9.61438 17.8333 10.1667 17.8333C10.719 17.8333 11.1667 17.3856 11.1667 16.8333H10.1667H9.16667ZM8.5 4.33333L7.56367 4.68446L8.5 7.18133L9.43633 4.68446L8.5 4.33333ZM11.2786 3.50128C10.8191 3.80764 10.6949 4.4285 11.0013 4.88803C11.3076 5.34756 11.9285 5.47174 12.388 5.16538L11.8333 4.33333L11.2786 3.50128ZM4.61197 5.16538C5.0715 5.47174 5.69236 5.34756 5.99872 4.88803C6.30507 4.4285 6.1809 3.80764 5.72137 3.50128L5.16667 4.33333L4.61197 5.16538ZM1.83333 7.66667V8.66667H15.1667V7.66667V6.66667H1.83333V7.66667ZM15.1667 7.66667H14.1667V14.1667H15.1667H16.1667V7.66667H15.1667ZM12.5 16.8333V15.8333H4.5V16.8333V17.8333H12.5V16.8333ZM1.83333 14.1667H2.83333V7.66667H1.83333H0.833333V14.1667H1.83333ZM4.5 16.8333V15.8333C4.01679 15.8333 3.71452 15.8326 3.48677 15.8139C3.27069 15.7963 3.21113 15.7677 3.19734 15.7607L2.74335 16.6517L2.28936 17.5427C2.63209 17.7173 2.98414 17.7795 3.3239 17.8073C3.65199 17.8341 4.04979 17.8333 4.5 17.8333V16.8333ZM1.83333 14.1667H0.833333C0.833333 14.6169 0.832556 15.0147 0.859361 15.3428C0.887121 15.6825 0.949354 16.0346 1.12398 16.3773L2.01499 15.9233L2.906 15.4693C2.89897 15.4555 2.87037 15.396 2.85272 15.1799C2.83411 14.9521 2.83333 14.6499 2.83333 14.1667H1.83333ZM2.74335 16.6517L3.19734 15.7607C3.0719 15.6968 2.96991 15.5948 2.906 15.4693L2.01499 15.9233L1.12398 16.3773C1.37965 16.8791 1.78759 17.287 2.28936 17.5427L2.74335 16.6517ZM15.1667 14.1667H14.1667C14.1667 14.6499 14.1659 14.9521 14.1473 15.1799C14.1296 15.396 14.101 15.4555 14.094 15.4693L14.985 15.9233L15.876 16.3773C16.0506 16.0346 16.1129 15.6825 16.1406 15.3428C16.1674 15.0147 16.1667 14.6169 16.1667 14.1667H15.1667ZM12.5 16.8333V17.8333C12.9502 17.8333 13.348 17.8341 13.6761 17.8073C14.0159 17.7795 14.3679 17.7173 14.7106 17.5427L14.2567 16.6517L13.8027 15.7607C13.7889 15.7677 13.7293 15.7963 13.5132 15.8139C13.2855 15.8326 12.9832 15.8333 12.5 15.8333V16.8333ZM14.985 15.9233L14.094 15.4693C14.0301 15.5948 13.9281 15.6968 13.8027 15.7607L14.2567 16.6517L14.7106 17.5427C15.2124 17.287 15.6204 16.8791 15.876 16.3773L14.985 15.9233ZM2.33333 4.33333V5.33333H14.6667V4.33333V3.33333H2.33333V4.33333ZM16 5.66667H15V6.33333H16H17V5.66667H16ZM14.6667 7.66667V6.66667H2.33333V7.66667V8.66667H14.6667V7.66667ZM1 6.33333H2V5.66667H1H0V6.33333H1ZM2.33333 7.66667V6.66667C2.21437 6.66667 2.12081 6.66664 2.03998 6.66537C1.95913 6.6641 1.90539 6.66174 1.86743 6.65863C1.79031 6.65233 1.83366 6.64645 1.909 6.68483L1.45501 7.57584L1.00102 8.46685C1.25462 8.59606 1.50377 8.63559 1.70457 8.65199C1.8937 8.66744 2.11648 8.66667 2.33333 8.66667V7.66667ZM1 6.33333H0C0 6.55019 -0.000777721 6.77297 0.0146746 6.9621C0.0310807 7.1629 0.0706069 7.41205 0.199821 7.66565L1.09083 7.21166L1.98183 6.75767C2.02022 6.83301 2.01433 6.87635 2.00803 6.79923C2.00493 6.76128 2.00257 6.70754 2.0013 6.62668C2.00003 6.54585 2 6.45229 2 6.33333H1ZM1.45501 7.57584L1.909 6.68483C1.94036 6.70081 1.96586 6.72631 1.98183 6.75767L1.09083 7.21166L0.199821 7.66565C0.375589 8.01061 0.656054 8.29108 1.00102 8.46685L1.45501 7.57584ZM16 6.33333H15C15 6.45229 15 6.54585 14.9987 6.62668C14.9974 6.70754 14.9951 6.76128 14.992 6.79923C14.9857 6.87635 14.9798 6.83301 15.0182 6.75767L15.9092 7.21166L16.8002 7.66565C16.9294 7.41205 16.9689 7.1629 16.9853 6.9621C17.0008 6.77297 17 6.55019 17 6.33333H16ZM14.6667 7.66667V8.66667C14.8835 8.66667 15.1063 8.66744 15.2954 8.65199C15.4962 8.63559 15.7454 8.59606 15.999 8.46685L15.545 7.57584L15.091 6.68483C15.1663 6.64645 15.2097 6.65233 15.1326 6.65863C15.0946 6.66174 15.0409 6.6641 14.96 6.66537C14.8792 6.66664 14.7856 6.66667 14.6667 6.66667V7.66667ZM15.9092 7.21166L15.0182 6.75767C15.0341 6.72631 15.0596 6.70081 15.091 6.68483L15.545 7.57584L15.999 8.46685C16.3439 8.29108 16.6244 8.01061 16.8002 7.66565L15.9092 7.21166ZM14.6667 4.33333V5.33333C14.7856 5.33333 14.8792 5.33336 14.96 5.33463C15.0409 5.3359 15.0946 5.33826 15.1326 5.34137C15.2097 5.34767 15.1663 5.35355 15.091 5.31517L15.545 4.42416L15.999 3.53315C15.7454 3.40394 15.4962 3.36441 15.2954 3.34801C15.1063 3.33256 14.8835 3.33333 14.6667 3.33333V4.33333ZM16 5.66667H17C17 5.44981 17.0008 5.22703 16.9853 5.0379C16.9689 4.8371 16.9294 4.58795 16.8002 4.33435L15.9092 4.78834L15.0182 5.24233C14.9798 5.16699 14.9857 5.12365 14.992 5.20077C14.9951 5.23872 14.9974 5.29246 14.9987 5.37332C15 5.45415 15 5.54771 15 5.66667H16ZM15.545 4.42416L15.091 5.31517C15.0596 5.29919 15.0341 5.27369 15.0182 5.24233L15.9092 4.78834L16.8002 4.33435C16.6244 3.98939 16.3439 3.70892 15.999 3.53315L15.545 4.42416ZM2.33333 4.33333V3.33333C2.11648 3.33333 1.8937 3.33256 1.70457 3.34801C1.50377 3.36441 1.25462 3.40394 1.00102 3.53315L1.45501 4.42416L1.909 5.31517C1.83366 5.35355 1.79031 5.34767 1.86743 5.34137C1.90539 5.33826 1.95913 5.3359 2.03998 5.33463C2.12081 5.33336 2.21437 5.33333 2.33333 5.33333V4.33333ZM1 5.66667H2C2 5.54771 2.00003 5.45415 2.0013 5.37332C2.00257 5.29246 2.00493 5.23872 2.00803 5.20077C2.01433 5.12365 2.02022 5.16699 1.98183 5.24233L1.09083 4.78834L0.199821 4.33435C0.0706069 4.58795 0.0310807 4.8371 0.0146746 5.0379C-0.000777721 5.22703 0 5.44981 0 5.66667H1ZM1.45501 4.42416L1.00102 3.53315C0.656054 3.70892 0.375589 3.98939 0.199821 4.33435L1.09083 4.78834L1.98183 5.24233C1.96586 5.27369 1.94036 5.29919 1.909 5.31517L1.45501 4.42416ZM6.83333 7.66667H5.83333V16.8333H6.83333H7.83333V7.66667H6.83333ZM10.1667 7.66667H9.16667V16.8333H10.1667H11.1667V7.66667H10.1667ZM8.5 4.33333L9.43633 4.68446C9.6152 4.20746 9.98194 3.47711 10.4693 2.88638C10.9811 2.26603 11.4546 2 11.8333 2V1V0C10.5454 0 9.56059 0.845081 8.92654 1.61362C8.26806 2.41178 7.80146 3.3481 7.56367 3.98221L8.5 4.33333ZM11.8333 1V2C12.0895 2 12.2524 2.06455 12.3333 2.11851C12.4051 2.16638 12.4081 2.1981 12.4094 2.20607C12.4133 2.22929 12.4309 2.73312 11.2786 3.50128L11.8333 4.33333L12.388 5.16538C13.7358 4.26688 14.5867 3.10405 14.3822 1.87727C14.167 0.585999 12.9417 0 11.8333 0V1ZM8.5 4.33333L9.43633 3.98221C9.19854 3.3481 8.73194 2.41178 8.07346 1.61362C7.43941 0.845081 6.45455 0 5.16667 0V1V2C5.54545 2 6.01892 2.26603 6.53071 2.88638C7.01806 3.47711 7.3848 4.20746 7.56367 4.68446L8.5 4.33333ZM5.16667 1V0C4.05828 0 2.83298 0.585999 2.61777 1.87727C2.41331 3.10405 3.2642 4.26688 4.61197 5.16538L5.16667 4.33333L5.72137 3.50128C4.56913 2.73312 4.58669 2.22929 4.59056 2.20607C4.59189 2.1981 4.59487 2.16638 4.66668 2.11851C4.74762 2.06455 4.91053 2 5.16667 2V1Z"
        fill="#6750B8"
      />
    </svg>
  )
};
const StarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M9.59244 2.82932C9.68325 2.38502 10.3181 2.38502 10.4089 2.82932L11.1154 6.28572C11.3828 7.59411 12.4053 8.6166 13.7137 8.88403L17.1701 9.59049C17.6144 9.6813 17.6144 10.3161 17.1701 10.4069L13.7137 11.1134C12.4053 11.3808 11.3828 12.4033 11.1154 13.7117L10.4089 17.1681C10.3181 17.6124 9.68325 17.6124 9.59244 17.1681L8.88598 13.7117C8.61856 12.4033 7.59606 11.3808 6.28767 11.1134L2.83128 10.4069C2.38697 10.3161 2.38697 9.6813 2.83128 9.59049L6.28767 8.88403C7.59606 8.6166 8.61856 7.59411 8.88598 6.28572L9.59244 2.82932Z"
        stroke="#6750B8"
        strokeWidth={2}
      />
    </svg>
  )
}


const HolidayOfferCard: React.FC<{ freeInvoiceCount: number; fillPercentage: number }> = ({ freeInvoiceCount, fillPercentage }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';


  return (
    <div className="loyalty-sidebar__holiday-offer-card">
      <div className="loyalty-sidebar__holiday-offer-header">
        <div className="loyalty-sidebar__holiday-offer-icon">
          <PresentIcon />
        </div>
        <div className="loyalty-sidebar__holiday-offer-title">{t('HOLIDAY_OFFER')}</div>
      </div>
      <div className="loyalty-sidebar__holiday-offer-content">
        <div className="loyalty-sidebar__holiday-offer-main-title">{3 - freeInvoiceCount} {t('FREE_INVOICES')}</div>
        <div className="loyalty-sidebar__holiday-offer-desc">{t('FREE_INVOICE_CREDITS_DESC')}</div>
        <div className="loyalty-sidebar__holiday-offer-box">
          <div className="loyalty-sidebar__holiday-offer-box-header">
            <span>{t('FREE_INVOICES_REMAINING')}</span>
            <span className="loyalty-sidebar__holiday-offer-star">
              <StarIcon />
            </span>
          </div>
          <div className="loyalty-sidebar__holiday-offer-count">{3 - freeInvoiceCount}</div>
          <div className="loyalty-sidebar__holiday-offer-ready">{t('READY_TO_USE')}</div>
          <div className="loyalty-sidebar__holiday-offer-progress-bar">
            <div className="loyalty-sidebar__progress-bar-fill-${}" style={{ width: `${fillPercentage}%` }} />
          </div>
        </div>
        <button className="loyalty-sidebar__holiday-offer-btn"
        onClick={()=>{
          navigate(`/v2/create-invoice?lang=${lang}`);
        }}
        >
          {t('CREATE_FREE_INVOICE')}
        </button>
      </div>
    </div>
  );
};


// Header Section Component (Single Responsibility)
const LoyaltyHeaderSection: React.FC<LoyaltyHeaderProps> = ({ title, description, icon }) => (
  <div className="loyalty-sidebar__header">
    <div className="loyalty-sidebar__header-top">
      {icon && <div className="loyalty-sidebar__header-icon">{icon}</div>}
      <h2 className="loyalty-sidebar__header-title">{title}</h2>
    </div>
    <p className="loyalty-sidebar__header-description">{description}</p>
  </div>
);

// Hero Card Component (Single Responsibility)
const InvoiceEarnPerksCard: React.FC<HeroCardProps> = ({
  title,
  description,
  buttonText,
  onButtonClick
}) => (
  <div className="loyalty-sidebar__hero-card">

    <div className="loyalty-sidebar__hero-content">
      <div className="loyalty-sidebar__hero-text loyalty-sidebar__hero-text--align-end">
        <h3 className="loyalty-sidebar__hero-title text-start">{title}</h3>
        <p className="loyalty-sidebar__hero-description">{description}</p>
        <button
          className="loyalty-sidebar__hero-button"
          onClick={onButtonClick}
        >
          <span>{buttonText}</span>
          <ArrowRightIcon />
        </button>
      </div>
    </div>
  </div>
);

const TierStatusWidget: React.FC<TierWidgetProps> = ({ tierData, onViewMore }) => {
  const { t } = useTranslation();
  const calculatePercentage = (earned: number = 0, required: number = 1): number => {
    return (earned / required) * 100;
  };
  const getMedalImage = (medalType: 'Iron' | 'Bronze' | 'Silver' | 'Gold' | 'Platinum') => {
    switch (medalType) {
      case 'Iron':
        return ironMedal;
      case 'Bronze':
        return bronzeMedal;
      case 'Silver':
        return silverMedal;
      case 'Gold':
        return goldMedal;
      case 'Platinum':
        return platinumMedal;
      default:
        return bronzeMedal;
    }
  };
  return (
    <div className="loyalty-sidebar__tier-widget">
      <div className="loyalty-sidebar__tier-header">
        <span className="loyalty-sidebar__tier-label">{t('YOUR_LOYALTY_STATUS')}</span>
      </div>
      <div className="loyalty-sidebar__current-reward-row">
        <span className="current-tier-label">{t('CURRENT_REWARD')}</span>
      </div>
      <div className="loyalty-sidebar__reward-row">
        {getMedalImage(tierData?.response?.loyaltyTierName)}
      </div>
      <div className="loyalty-sidebar__tier-name-row">{t('JUST_STARTED')}</div>
      <div className="loyalty-sidebar__progress-bar-row">
        <div className="loyalty-sidebar__points-row pb-2">
          <span>{t('INVOICE_DISCOUNT')}</span>
          <span>{tierData?.response.discountPercentage || 0}% {(t('OFF'))}</span>
        </div>
        <div className="loyalty-sidebar__progress-bar-bg">
          <div
            className={`loyalty-sidebar__progress-bar-fill-widget-${tierData?.response?.loyaltyTierName}`}
            style={{ width: `${calculatePercentage(tierData?.response?.pointsEarned, tierData?.response?.pointsRequired)}%` }}
          />
        </div>
      </div>
      <div className="loyalty-sidebar__points-row">
        <span>{t('YOUR_POINTS')}</span>
        <span>{formatAmount(tierData?.response?.pointsEarned || 0)} / {formatAmount(tierData?.response?.pointsRequired || 0)}</span>
      </div>
    </div>
  );
};

// Getting Started Section Component (Single Responsibility)
const GettingStartedSection: React.FC<GettingStartedProps> = ({
  title,
  subtitle,
  progress,
  items,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate()
  const language = new URLSearchParams(window.location.search).get('lang') || 'en-us';
  function handleRedirection(){
    navigate(`/profile-settings?lang=${language}`)
  }
  return (
    <div className="loyalty-sidebar__getting-started" >
      <div className="loyalty-sidebar__getting-started-header">
        <div className="loyalty-sidebar__getting-started-content">
          <h3 className="loyalty-sidebar__getting-started-title">{title}</h3>
          <p className="loyalty-sidebar__getting-started-subtitle">{subtitle}</p>
        </div>
        <div className="loyalty-sidebar__progress-section">
          <div className="loyalty-sidebar__progress-bar-container">
            <div className="loyalty-sidebar__progress-bar-bg">
              <div
                className="loyalty-sidebar__progress-bar-fill"
                style={{ width: `${progress}%` }}
              />
            </div>
            <span className="loyalty-sidebar__progress-text">{progress}%</span>
          </div>
        </div>
      </div>

      <div className="loyalty-sidebar__getting-started-items">
        {items?.map((item) => (
          <div key={item.id} className="loyalty-sidebar__getting-started-item">
            <div className="loyalty-sidebar__item-checkbox">
              <div className={`loyalty-sidebar__checkbox ${item.completed ? 'completed' : ''}`}>
                {item.completed && <span className="loyalty-sidebar__checkbox-check">✓</span>}
              </div>
            </div>
            <button
              className="loyalty-sidebar__item-button"
            >
              {t(item.title)}
            </button>
          </div>
        ))}
        <button
          style={{
            color: "#6750B8",
            fontSize: 14,
            fontStyle: "normal",
            fontWeight: 700,
            textAlign:'start',
            lineHeight: "20px",
            letterSpacing: "0.1px",
            cursor:'pointer'
          }}
          onClick={() => handleRedirection()}
>
          {t('COMPLETE_YOUR_PROFILE')} <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M4.69922 11.2989L10.8275 5.17062M5.64203 4.69922H10.6322C11.0004 4.69922 11.2989 4.9977 11.2989 5.36589V10.3561"
              stroke="#6750B8"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>
      </div>
    </div>

  );
}

const LoyaltySidebar: React.FC<LoyaltySidebarProps> = ({
  className = '',
  dataProvider,
}) => {
  const [loyaltyData1, setLoyaltyData] = useState<LoyaltyData | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch<AppDispatch>();
  const { loyaltyData } = useSelector((state: RootState) => state.loyalityStatus);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { userOnboardingData } = useSelector((state: any) => state.auth);
  const progressPercentage = userOnboardingData?.onBoardingPercentage || 0;
  const lang = new URLSearchParams(window.location.search).get('lang') || 'en-us';
  const [freeInvoiceCount, setFreeInvoiceCount] = useState<number>(0);
  const [fillPercentage, setFillPercentage] = useState<number>(0);
    const [user, setUser] = useState(() => {
      try {
        return JSON.parse(localStorage.getItem("user") as string);
      } catch {
        return null;
      }
    });

  useEffect(() => {
    const fetchFreeInvoiceCount = async () => {
      try {
        const response = await get('/invoice/get-user-free-invoice-count');
        if (response) {
          setFreeInvoiceCount(response);
          const percentage = (response / 3) * 100;
          setFillPercentage(percentage);
        }
        return
      } catch (error) {
        console.error("Error fetching free invoice count:", error);
      }
    };

    fetchFreeInvoiceCount();
  }, []);

  const fetchLoyaltyData = useCallback(async () => {
    try {
      setLoading(true);
      if (dataProvider) {
        const data = await dataProvider.getLoyaltyData();
        setLoyaltyData(data);
      }
      await dispatch(fetchLoyaltyStatusAsync()).unwrap();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load loyalty data');
    } finally {
      setLoading(false);
    }
  }, [dataProvider, dispatch]);

  useEffect(() => {
    fetchLoyaltyData();
  }, [fetchLoyaltyData]);

  const handleExploreProgram = () => {
    navigate(`/loyalty-program?lang=${lang}`);
  };

  function getCreatedDate() {
  return user?.userData?.createdDate?.split("T")[0] < "2026-04-17";
}

  return (
    <div className={`loyalty-sidebar ${className}`}>
      <div className="loyalty-sidebar__container">
        {/* Header Section */}

        <div className='wrapper-for-loyalty-header-section'>
          <LoyaltyHeaderSection
            title={t('LEVEL_UP_WITH_LOYALTY_POINTS')}
            description={t('EVERY_ACTION_COUNTS')}
            icon={<TrendingUpIcon />}
          />

          {/* Hero Card */}
          <InvoiceEarnPerksCard
            title={t('INVOICE_AND_EARN_EXCLUSIVE_PERKS')}
            description={t('INVOICING_PAYS_OFF')}
            buttonText={t('EXPLORE_LOYALTY_PROGRAM')}
            onButtonClick={handleExploreProgram}
          />
          {/* Tier Widget */}
          {loyaltyData && (
            <TierStatusWidget
              tierData={loyaltyData}
            />
          )}

        </div>
        <GettingStartedSection
          title={t('GETTING_STARTED')}
          subtitle={t('FIRST_STEP')}
          progress={progressPercentage}
          items={loyaltyData1?.gettingStarted.items || []}
        />
        {freeInvoiceCount < 3 && getCreatedDate() && (
          <HolidayOfferCard
            fillPercentage={fillPercentage}
            freeInvoiceCount={freeInvoiceCount}
          />
        )
        }
      </div>
    </div>
  );
};

export default LoyaltySidebar;
